function playAudio() {
    const URL = 'https://upload.wikimedia.org/wikipedia/commons/a/ab/Save_a_Little_Dram_for_Me.ogg';
    const context = new AudioContext();

    window.fetch(URL)
        .then(response => response.arrayBuffer())
        .then(arrayBuffer => context.decodeAudioData(arrayBuffer))
        .then(audioBuffer => {
            const source = context.createBufferSource();
            source.buffer = audioBuffer;
            source.connect(context.destination);
            source.start();
        });
}

function enableCss() {
    const htmlTag = document.querySelector('html');
    htmlTag.classList.add('roaring-twenties');
}

function addFonts() {
    const linkEl = document.createElement('link');
    linkEl.href = 'https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap';
    linkEl.rel = 'stylesheet';

    document.head.appendChild(linkEl);
}

export default function theEgg() {
    const isEnabled = window.location.hash === '#roaring-twenties';

    if (!isEnabled) {
        return;
    }

    addFonts();
    enableCss();
    playAudio();
}
